// import { useEffect, useState } from "react";
// import "../css/NewsTicker.css";

// const statsData = [
//   { id: 1, icon: "fas fa-users", number: 500, label: "Happy Customers" },
//   { id: 2, icon: "fas fa-university", number: 5, label: "Banking Outlets" },
//   { id: 3, icon: "fas fa-credit-card", number: 10, label: "ATMs" },
//   { id: 4, icon: "fas fa-wallet", number: 100, label: "Cash Recyclers" },
// ];

// const linksData = [
//   { id: 1, icon: "fas fa-calculator", label: "Banking Tools" },
//   { id: 2, icon: "fas fa-file-invoice-dollar", label: "Rates & Charges" },
//   { id: 3, icon: "fas fa-headset", label: "Need Assistance" },
//   { id: 4, icon: "fas fa-link", label: "Quick Links" },
// ];

// const CountUp = ({ target }) => {
//   const [count, setCount] = useState(0);

//   useEffect(() => {
//     let start = 0;
//     const duration = 2000; // 2 seconds
//     const increment = target / (duration / 16);

//     const timer = setInterval(() => {
//       start += increment;
//       if (start >= target) {
//         setCount(target);
//         clearInterval(timer);
//       } else {
//         setCount(Math.floor(start));
//       }
//     }, 16);

//     return () => clearInterval(timer);
//   }, [target]);

//   return <>{count.toLocaleString()}</>;
// };

// const StatisticsPanel = () => {
//   return (
//     <div className="stats-panel-container">
//       {/* Top Stats Row */}
//       <div className="stats-row">
//         {statsData.map((stat) => (
//           <div key={stat.id} className="stat-item">
//             <div className="stat-icon">
//               <i className={stat.icon}></i>
//             </div>
//             <div className="stat-number">
//               <CountUp target={stat.number} />
//             </div>
//             <div className="stat-label">{stat.label}</div>
//           </div>
//         ))}
//       </div>

//       {/* Bottom Links Panel */}
//       <div className="links-panel">
//         {linksData.map((link, idx) => (
//           <div
//             key={link.id}
//             className={`link-item ${idx === 0 ? "first" : ""} ${
//               idx === linksData.length - 1 ? "last" : ""
//             }`}
//           >
//             <div className="link-icon">
//               <i className={link.icon}></i>
//             </div>
//             <div className="link-label">{link.label}</div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default StatisticsPanel;

import { useEffect, useState } from "react";
import "../css/NewsTicker.css";

const statsData = [
  { id: 1, icon: "fas fa-users", number: 12500, label: "Active Members", suffix: "+" },
  { id: 2, icon: "fas fa-hand-holding-usd", number: 85, label: "Loans Disbursed", suffix: "M+" },
  { id: 3, icon: "fas fa-chart-line", number: 98, label: "Repayment Rate", suffix: "%" },
  { id: 4, icon: "fas fa-shield-alt", number: 100, label: "Secure Deposits", suffix: "%" },
];

const linksData = [
  { id: 1, icon: "fas fa-calculator", label: "EMI Calculator" },
  { id: 2, icon: "fas fa-file-signature", label: "Loan Eligibility" },
  { id: 3, icon: "fas fa-users-cog", label: "Group Banking" },
  { id: 4, icon: "fas fa-info-circle", label: "Social Impact" },
];

const CountUp = ({ target }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 2000;
    const increment = target / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [target]);

  return <>{count.toLocaleString()}</>;
};

const StatisticsPanel = () => {
  return (
    <section className="mfi-stats-section">
      <div className="mfi-container">
        {/* Statistics Grid */}
        <div className="mfi-stats-grid">
          {statsData.map((stat) => (
            <div key={stat.id} className="mfi-stat-card">
              <div className="mfi-stat-icon-wrapper">
                <i className={stat.icon}></i>
              </div>
              <div className="mfi-stat-content">
                <h3 className="mfi-stat-number">
                  <CountUp target={stat.number} />{stat.suffix}
                </h3>
                <p className="mfi-stat-label">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Quick Access Toolbar */}
        <div className="mfi-quick-access">
          {linksData.map((link) => (
            <div key={link.id} className="mfi-access-item">
              <div className="mfi-access-icon">
                <i className={link.icon}></i>
              </div>
              <span className="mfi-access-label">{link.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatisticsPanel;